import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { TeamappProvider} from "../../providers/teamapp";
import { UserProvider} from "../../providers/user";

/**
 * Generated class for the ChatGroupAddMemberPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-chat-group-add-member',
  templateUrl: 'chat-group-add-member.html',
})
export class ChatGroupAddMemberPage {
  searchFriend: string = '';

  params: any;
  user: any = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, public teamappProvider: TeamappProvider, public userProvider: UserProvider) {
    this.params = this.navParams.get('group');
    this.loadMembers();
  }

  loadMembers() {
    this.teamappProvider.http_request('action=get_chat_members', 'chat', false, true).then(data => {
        this.user = data;
    });
  }

  isUserMember(member: any) {
    for(let i = 0; i<this.params.member.length; i++) {
      if(this.params.member[i].token == member.token) {
        return true;
      }
    }
    return false;
  }

  add(member: any) {
    this.teamappProvider.http_request('action=add_member_to_group&single_target='+member.token+'&content='+this.params.groupId, 'chat', false, true).then(data => {
      this.loadGroupInfo();
    });
  }

  remove(member: any) {
    this.teamappProvider.http_request('action=remove_member_from_group&single_target='+member.token+'&content='+this.params.groupId, 'chat', false, true).then(data => {
      this.loadGroupInfo();
    });
  }


  loadGroupInfo() {
    this.teamappProvider.http_request('action=get_group_info&single_target='+this.params.groupId, 'chat', false, true).then(data => {
      let groupReturn: any = data;
      this.params.member = groupReturn.member;
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChatGroupAddMemberPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/chat-group-add-member/chat-group-add-member.ts